import templateUrl from "emun.invoice/inv/inv-summary.htm";
export default () => ({ templateUrl });
